import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

export const postEmpreendimentoRevendaCadastrar = async (params: {
  idEmpreendimentoCRM: string;
  nome: string;
  cep: string;
  logradouro: string;
  numero: string;
  bairro: string;
  cidade: string;
  uf: string;
  idRevendaRegiao: string;
  idsImobiliaria: string[];
  torres: { id: string | null; descricao: string }[];
  authToken: string;
}): Promise<any> => {
  const url = "api/RevendaEmpreendimento";
  const { authToken, ...parameters } = params;
  const _parameters = {
    ...parameters,
    idEmpreendimentoCRM: parameters.idEmpreendimentoCRM ?? null,
  };
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, _parameters, config);
  return response?.data;
};
